export const validate_not_empty = (node) => {
    if (!node.value) {
        node.setAttribute('data-error', true);
    }

    return {
        update (value) {
            if (!value) {
                node.setAttribute('data-error', true);
                node.setAttribute('style', 'border-color: red');
            } else {
                node.removeAttribute('data-error');
                node.removeAttribute('style');
            }
        }
    }
}

export const validate_int = (node) => {
    return {
        update (value) {
            let min = node.min ? node.min : 0,
                max = node.max ? node.max : Number.POSITIVE_INFINITY;

            if (value < min || value > max) {
                node.setAttribute('data-error', true);
                node.setAttribute('style', 'border-color: red');
            } else {
                node.removeAttribute('data-error');
                node.removeAttribute('style');
            }
        }
    }
}

export const validate_size = (node) => {
    return {
        update (value) {
            if (!value.match(/^(\d+\*\d+)$/)) {
                node.setAttribute('data-error', true);
                node.setAttribute('style', 'border-color: red');
            } else {
                node.removeAttribute('data-error');
                node.removeAttribute('style');
            }
        }
    }
}